/**
 * Categorized icon catalog for the template icon picker
 * (IconPickerSheet). Shared, single source of truth so template
 * icons stay consistent everywhere they're eventually consumed
 * (テンプレート一覧・予定追加画面・カレンダー・予定一覧・LINE通知).
 */
export const ICON_CATALOG = [
  {
    category: '人物',
    categoryIcon: '👤',
    items: [
      { icon: '👴', label: 'じーちゃん' },
      { icon: '👵', label: 'ばーちゃん' },
      { icon: '👨', label: 'パパ' },
      { icon: '👩', label: 'ママ' },
      { icon: '👦', label: '男の子' },
      { icon: '👧', label: '女の子' },
      { icon: '👶', label: '孫' },
      { icon: '🐶', label: '犬' },
      { icon: '🐱', label: '猫' },
      { icon: '👨‍👩‍👧‍👦', label: '家族' },
    ],
  },
  {
    category: '医療',
    categoryIcon: '🏥',
    items: [
      { icon: '🏥', label: '病院' },
      { icon: '🦷', label: '歯医者' },
      { icon: '💊', label: '薬' },
      { icon: '💉', label: '注射' },
    ],
  },
  {
    category: '学校・習い事',
    categoryIcon: '🏫',
    items: [
      { icon: '🏫', label: '学校' },
      { icon: '📚', label: '勉強' },
      { icon: '📝', label: 'テスト' },
      { icon: '🎹', label: 'ピアノ' },
      { icon: '🎨', label: '絵画' },
      { icon: '🔤', label: '英語' },
    ],
  },
  {
    category: 'スポーツ・部活',
    categoryIcon: '🏅',
    items: [
      { icon: '🏅', label: 'スポーツ' },
      { icon: '⚽', label: 'サッカー' },
      { icon: '⚾', label: '野球' },
      { icon: '🏀', label: 'バスケ' },
      { icon: '🏐', label: 'バレー' },
      { icon: '🎾', label: 'テニス' },
      { icon: '🏃', label: 'ランニング' },
      { icon: '🏊', label: '水泳' },
      { icon: '🎺', label: '吹奏楽' },
    ],
  },
  {
    category: '移動・外出',
    categoryIcon: '🚗',
    items: [
      { icon: '🚗', label: '車' },
      { icon: '🚆', label: '電車' },
      { icon: '✈️', label: '飛行機' },
      { icon: '⛺', label: 'キャンプ' },
      { icon: '♨️', label: '温泉' },
    ],
  },
  {
    category: '買い物',
    categoryIcon: '🛒',
    items: [
      { icon: '🛒', label: '買い物' },
      { icon: '🛍️', label: 'ショッピング' },
    ],
  },
  {
    category: '食事',
    categoryIcon: '🍽️',
    items: [
      { icon: '🍖', label: '焼肉・肉料理' },
      { icon: '🍣', label: '外食' },
      { icon: '🍰', label: 'スイーツ' },
      { icon: '☕', label: 'カフェ' },
      { icon: '🍺', label: 'お酒' },
    ],
  },
  {
    category: 'イベント',
    categoryIcon: '🎉',
    items: [
      { icon: '🎂', label: '誕生日' },
      { icon: '🎉', label: 'イベント' },
      { icon: '🎁', label: 'プレゼント' },
      { icon: '❤️', label: '記念日' },
    ],
  },
  {
    category: 'その他',
    categoryIcon: '📌',
    items: [
      { icon: '📅', label: 'カレンダー' },
      { icon: '⭐', label: '重要' },
      { icon: '📌', label: 'ピン留め' },
      { icon: '✅', label: '完了' },
    ],
  },
];

export const MAX_TEMPLATE_ICONS = 4;
